module.exports = __webpack_public_path__ + "img/2560_1440-min.733e4215.png";